export const queryKeys = {
  consentPurposes: {
    all: ['consent-purposes'] as const,
    lists: () => [...queryKeys.consentPurposes.all, 'list'] as const,
    list: (filters?: Record<string, any>) =>
      [...queryKeys.consentPurposes.lists(), filters] as const,
    details: () => [...queryKeys.consentPurposes.all, 'detail'] as const,
    detail: (id: string) =>
      [...queryKeys.consentPurposes.details(), id] as const,
  },
};
